'use client'

import { ButtonPrimary } from 'fukku/Button/Primary'
import { useLabels } from 'labels/hooks/useLabels/useLabels'

import styles from './SaveRefundDataButton.module.scss'

interface SaveRefundDataButtonProps {
	readonly onSave: () => void
	readonly isLoading: boolean
}

export function SaveRefundDataButton({
	onSave,
	isLoading,
}: SaveRefundDataButtonProps) {
	const { t } = useLabels()

	return (
		<ButtonPrimary
			id='save-button'
			data-testid='myRefunds.saveSelection.button'
			className={styles.container}
			type='submit'
			onClick={onSave}
			isLoading={isLoading}
		>
			{t('myRefunds.saveSelection.button')}
		</ButtonPrimary>
	)
}
